import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import PleasePage from './pages/PleasePage';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/ask" element={<Navigate to="/" replace />} />
        <Route path="/please/:s" element={<PleasePage />} />
      </Routes>
    </div>
  );
}

export default App;
